import { Switch } from '@/components/ui/switch'
import { useUISettingsStore } from '@/store/useUISettingsStore'

import {
  DRAG_MODE_OPTIONS,
  DUAL_READING_ORDER_OPTIONS,
  PAGE_MODE_OPTIONS,
  type ReaderLayout,
  READING_DIRECTION_OPTIONS,
} from './reader-layout'
import { Segmented, SettingRow } from './setting-controls'

type Props = {
  value: ReaderLayout
  onChange: (layout: ReaderLayout) => void
  /** 方向と送り方だけを出す（初回のカード用） */
  compact?: boolean
  canChoosePageMode?: boolean
}

/** 方向・送り方・ページ配置・見開きの並び。コミック・PDF の設定ダイアログと初回のカードで共通 */
export const ReaderLayoutFields = ({ value, onChange, compact = false, canChoosePageMode = true }: Props) => {
  const pageTurnAnimation = useUISettingsStore((state) => state.pageTurnAnimation)
  const setPageTurnAnimation = useUISettingsStore((state) => state.setPageTurnAnimation)
  const set = <K extends keyof ReaderLayout>(key: K, next: ReaderLayout[K]) => onChange({ ...value, [key]: next })

  return (
    <>
      <SettingRow label="方向">
        <Segmented
          options={READING_DIRECTION_OPTIONS}
          value={value.direction}
          onChange={(next) => set('direction', next)}
        />
      </SettingRow>

      <SettingRow label="送り方">
        <Segmented options={DRAG_MODE_OPTIONS} value={value.dragMode} onChange={(next) => set('dragMode', next)} />
      </SettingRow>

      {!compact && value.dragMode === 'snap' && (
        <SettingRow label="アニメーション" htmlFor="page-turn-animation" labelClassName="w-auto cursor-pointer">
          <Switch id="page-turn-animation" checked={pageTurnAnimation} onCheckedChange={setPageTurnAnimation} />
        </SettingRow>
      )}

      {!compact && canChoosePageMode && (
        <SettingRow label="ページ配置">
          <Segmented options={PAGE_MODE_OPTIONS} value={value.pageMode} onChange={(next) => set('pageMode', next)} />
        </SettingRow>
      )}

      {!compact && value.direction === 'ttb' && value.pageMode !== 'single' && (
        <SettingRow label="見開きの並び">
          <Segmented
            options={DUAL_READING_ORDER_OPTIONS}
            value={value.dualReadingOrder}
            onChange={(next) => set('dualReadingOrder', next)}
          />
        </SettingRow>
      )}
    </>
  )
}
